function init(){
  var backdrop = document.querySelector('[data-sg-backdrop]');
  var sheet = document.querySelector('[data-sg-sheet]');
  if(!backdrop||!sheet) return;
  if(backdrop.parentNode !== document.body) document.body.appendChild(backdrop);
  if(sheet.parentNode !== document.body) document.body.appendChild(sheet);
  var brandSel = sheet.querySelector('[data-sg-brand]');
  var typeSel = sheet.querySelector('[data-sg-type]');
  var empty = sheet.querySelector('[data-sg-empty]');
  var closeBtn = sheet.querySelector('[data-sg-close]');
  if(!brandSel||!typeSel||!closeBtn) return;

  var tables = Array.prototype.slice.call(sheet.querySelectorAll('.sg-gt'));
  var measures = Array.prototype.slice.call(sheet.querySelectorAll('[data-sg-measure]'));
  var caveats = Array.prototype.slice.call(sheet.querySelectorAll('[data-sg-caveat]'));

  var index = {};
  try {
    var node = document.querySelector('[data-sg-index]');
    if(node) index = JSON.parse(node.textContent);
  } catch(e){ index = {}; }
  if(!Object.keys(index).length){
    tables.forEach(function(t){
      var b=t.getAttribute('data-brand'), ty=t.getAttribute('data-type');
      (index[b]=index[b]||[]).push(ty);
    });
  }
  var brands = Object.keys(index).sort();
  if(!brands.length) return;

  var isOpen=false;

  function fill(sel, items, chosen){
    sel.innerHTML='';
    items.forEach(function(v){
      var o=document.createElement('option');o.value=v;o.textContent=v;
      if(v===chosen)o.selected=true;sel.appendChild(o);
    });
  }
  function show(){
    var b=brandSel.value, ty=typeSel.value, any=false;
    tables.forEach(function(t){
      var on=t.getAttribute('data-brand')===b && t.getAttribute('data-type')===ty;
      t.hidden=!on; if(on)any=true;
    });
    if(empty) empty.hidden=any;
    measures.forEach(function(m){
      m.hidden=!(m.getAttribute('data-brand')===b && m.getAttribute('data-type')===ty);
    });
    caveats.forEach(function(c){ c.hidden=c.getAttribute('data-brand')!==b; });
  }
  brandSel.addEventListener('change',function(){fill(typeSel,index[brandSel.value]||[]);show();});
  typeSel.addEventListener('change',show);

  // Now takes the specific button that was clicked, instead of a single
  // cached one — this is what makes every data-sg-open button work,
  // not just the first one found on the page.
  function openSheet(triggerBtn){
    var v = (triggerBtn && triggerBtn.getAttribute('data-vendor')) || '';
    var landtype = (triggerBtn && triggerBtn.getAttribute('data-landtype')) || '';
    var brand = index[v] ? v : brands[0];
    fill(brandSel, brands, brand);
    var types = index[brand]||[];
    var chosenType = types.indexOf(landtype)>-1 ? landtype : types[0];
    fill(typeSel, types, chosenType);
    show();
    sheet.hidden=false;
    sheet.classList.add('sg-prep');
    backdrop.style.display='block';
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        backdrop.classList.add('sg-open');
        sheet.classList.add('sg-open');
      });
    });
    document.documentElement.style.overflow='hidden';
    document.body.style.overflow='hidden';
    isOpen=true;
  }
  function closeSheet(){
    backdrop.classList.remove('sg-open');sheet.classList.remove('sg-open');
    document.documentElement.style.overflow='';
    document.body.style.overflow='';
    isOpen=false;
    window.setTimeout(function(){
      if(!isOpen){
        sheet.classList.remove('sg-prep');
        sheet.hidden=true;
        backdrop.style.display='';
      }
    },360);
  }

  // Delegated: catches every [data-sg-open] button on the page, including
  // ones added later (e.g. inside a FAQ accordion), not just the first.
  document.addEventListener('click', function(e){
    var openTrigger = e.target.closest('[data-sg-open]');
    if(openTrigger){ e.preventDefault(); openSheet(openTrigger); return; }
  });

  function bindClose(el){
    if(!el) return;
    el.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();closeSheet();});
    el.addEventListener('touchend',function(e){e.preventDefault();e.stopPropagation();closeSheet();},{passive:false});
  }
  bindClose(closeBtn);
  bindClose(backdrop);

  document.addEventListener('click',function(e){
    var t=e.target;
    while(t&&t!==document){
      if(t.hasAttribute&&t.hasAttribute('data-sg-close')){closeSheet();return;}
      t=t.parentNode;
    }
  });
  document.addEventListener('keydown',function(e){
    if((e.key==='Escape'||e.key==='Esc')&&isOpen)closeSheet();
  });
  window.addEventListener('pageshow',function(){
    if(sheet.hidden){document.documentElement.style.overflow='';document.body.style.overflow='';}
  });
}